<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control' :class='!selected ? "field-error-warrant" : ""'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ACTION_TYPE = 'get_action_type.php'
	const LOCATION = 'get_warrant_location.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'actionType',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: ''
		},
		methods: {
			change () {
				EventBus.$emit('warrant_action_type', {index: this.line_count, value: this.selected})
			}
		},
		created: function () {
			fetch(DB + LOCATION + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[this.line_count].f_84
			})
			.then(id => {
				fetch(DB + ACTION_TYPE, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = data

						this.selected = id

						EventBus.$emit('warrant_action_type', {index: this.line_count, value: id})
					}
					else {
						this.options = []
						this.selected = '0'
					}
				})
				.catch(err => console.log('7',err))
			})
			.catch(err => console.log('8',err))
		}
	}
</script>

<style scoped>
	select option {
		background: #fff !important;
	}
</style>


// WEBPACK FOOTER //
// actionType.vue?36cec85a